import { jwtDecode } from 'jwt-decode';

export const getBasketIdBasedRateLimitingHeader = (jwt?: string) => {
  if (!jwt) {
    return undefined;
  }
  return jwtDecode<{ rBasketId?: string }>(jwt).rBasketId;
};
